import React from "react"
import SbEditable from "storyblok-react"
import { PeopleStoryblok } from "../../../component-types-sb"
import Image from "../general/Image"
import { ImageWrapper } from "../general/Card"
import { P } from "../typography/Typography"

interface Props {
  readonly blok: PeopleStoryblok
  readonly itemBackground?: string
}

const PersonCard: React.FC<Props> = ({ blok, itemBackground }) => {
  const textColorStyle = {
    color: itemBackground ? "black" : "white",
  }

  // Determine the person data based on the structure of blok
  let person: PeopleStoryblok | null = null

  if ("person" in blok && blok.person)
    person = blok.person.content

  if (!person) return null

  return (
    <SbEditable content={blok}>
      <div tw="my-2 max-w-[366px] mx-auto w-full">
        <ImageWrapper aspectratio="1/1" tw="rounded-full">
          {person.photo && <Image image={person.photo} fluid={366} />}
        </ImageWrapper>
        <div tw="mt-2">
          <P tw="text-18 text-center font-medium mb-0" style={textColorStyle}>
            {person.name}
          </P>
          <P tw="text-16 text-center" style={textColorStyle}>
            {person.function}
          </P>
        </div>
      </div>
    </SbEditable>
  )
}

export default PersonCard
